export const findKeysWithPrefix = (headerMappings, prefix) =>{
  const matchingKeys = [];
  for (const [key, value] of Object.entries(headerMappings)) {
    if (Array.isArray(value)) {
      if (value.some(item => item.startsWith(prefix))) {
        matchingKeys.push(key);
      }
    } else if (typeof value === 'string') {
      if (value.startsWith(prefix)) {
        matchingKeys.push(key);
      }
    }
  }
  return matchingKeys;
}

export const getPrefixValues = (metaValues, key) => {
  return getMetaValues(metaValues, key);
}

/**
 * Generic function to get meta values based on a key.
 * @param metaValues 
 * @param key 
 * @returns 
 */
export const getMetaValues = (metaValues, key) => {
  const schoolCodes = metaValues.schoolCodes[key] || [];
  const districtCodes = metaValues.districtCodes[key] || [];
  const mergedCodes = [...new Set([...schoolCodes, ...districtCodes])];
  return mergedCodes.map(code => ({
    label: code,
    value: code,
  }));
}
